export default __webpack_public_path__ + "static/media/Shape.446cea32.svg";